export const enum ResidentialDepositTypes {
    creditCheck = 'creditCheck',
    deposit = 'deposit',
    proofOfExemption = 'proofOfException',
    exisitingCustomer = 'existingCustomer',
}
